import { useState } from "react";
import { Icon } from "@agentsaas/ui";
import type { Asset } from "@agentsaas/protocol";
import { useAssetUrl } from "../data/assets";

/**
 * 资产缩略图：图片 / 精灵图用 thumb 变体；模型有缩略图（hasThumb，来自供应商预览或转台图）时也用 thumb，
 * 列表里不知道 hasThumb（Asset 不带版本）时试着取一次，失败或拿到的不是图片就显示立方体图标。
 */
export function AssetThumb({ asset, version, hasThumb, className }: { asset: Pick<Asset, "id" | "kind" | "name">; version: number; hasThumb?: boolean; className?: string }) {
  const [broken, setBroken] = useState(false);
  const iconOnly = asset.kind === "audio" || asset.kind === "other" || (asset.kind === "model3d" && hasThumb === false);
  const thumb = useAssetUrl(iconOnly ? undefined : asset.id, version, "thumb", { optional: asset.kind === "model3d" });
  const url = thumb.data && thumb.data.mediaType.startsWith("image/") && !broken ? thumb.data.url : null;
  const cls = `asset-thumb${className ? ` ${className}` : ""}`;
  if (asset.kind === "model3d" || iconOnly) {
    if (url)
      return (
        <span className={cls} data-thumb="image">
          <img src={url} alt="" loading="lazy" onError={() => setBroken(true)} />
        </span>
      );
    return (
      <span className={`${cls} asset-thumb--icon`} aria-hidden="true" data-thumb="icon">
        <Icon name={asset.kind === "model3d" ? "cube" : "file"} size={36} />
      </span>
    );
  }
  return (
    <span className={cls} data-thumb="image">
      {thumb.data ? <img src={thumb.data.url} alt="" loading="lazy" /> : null}
    </span>
  );
}
